import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import CommonModal from "./CommonModal";
import { showToast } from "../../utils/utils";
import privateAxios from "../../utils/axiosPrivate";
import SalesLeadDatePicker from "../datepicker/SalesLeadDatePicker";
import Modalstyle from "./modal.module.scss";
import Style from "./../../assets/scss/custom.module.scss";
import "./modalstyle.scss";
import { EditReffPartner } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { getUserSalesLeadsURL } from "../../utils/constants/apiEndPoints";

const EdirRefferralEditSalesLeadModal = ({
  isOpen,
  toggle,
  salesLeadStatus,
  salesDataProp,
  loadSelectedSalesLead
}) => {
  const { id } = useParams();

  const initialSalesLead = {
    salesPersonLeadId: "",
    startDate: null,
    endDate: null
  };

  const [salesLead, setSalesLead] = useState(initialSalesLead);

  useEffect(() => {
    if (salesDataProp) {
      setSalesLead({
        ...salesDataProp,
        startDate: salesDataProp.startDate
          ? new Date(salesDataProp.startDate)
          : null,
        endDate: salesDataProp.endDate
          ? new Date(salesDataProp.endDate)
          : new Date()
      });
    }
  }, [salesDataProp]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSalesLead((prevFormData) => ({
      ...prevFormData,
      [name]: name === "salesPersonLeadId" ? parseInt(value, 10) : value
    }));
  };

  const handleDateChange = (field, selectedDate) => {
    const normalizedDate = selectedDate
      ? new Date(selectedDate.toISOString().split("T")[0])
      : null;
    setSalesLead((prevState) => ({
      ...prevState,
      [field]: normalizedDate
    }));
  };

  const handleSalesUpdate = async () => {
    try {
      const dataToSend = {
        salesPersonLeadId: salesLead.salesPersonLeadId,
        referralPartnerId: id,
        startDate: salesLead.startDate
          ? salesLead.startDate.toISOString().split("T")[0]
          : null,
        endDate: salesLead.endDate
          ? salesLead.endDate.toISOString().split("T")[0]
          : null
      };

      const response = await privateAxios.put(
        getUserSalesLeadsURL(salesDataProp.id),
        dataToSend
      );

      showToast(response.data.message, showToastType.success);
      if (response.status === 200) {
        toggle();
        loadSelectedSalesLead();
      }
    } catch (error) {
      if (error.response && error.response.status === 500) {
        showToast(error.response.data.errors, showToastType.error);
      } else if (error.response && error.response.status === 400) {
        showToast(error.response.data.errors, showToastType.error);
      } else {
        showToast(error.response.data.message, showToastType.error);
      }
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={EditReffPartner?.editReffModal?.title}
      modalClassName="modal-md"
      bodyClassName={Modalstyle.commentModalWrap}
      footerButtons={[
        {
          label: EditReffPartner?.editReffModal?.updatebtn,
          className: "btn btn-primary",
          onClick: handleSalesUpdate
        }
      ]}
    >
      <div className="row inputWrap">
        <div className="mb-3">
          <p>{EditReffPartner?.editReffModal?.salesLead}</p>
          <select
            name="salesPersonLeadId"
            className={Style.selectdropdown}
            onChange={handleInputChange}
            value={salesLead.salesPersonLeadId}
          >
            <option value="">{EditReffPartner?.editReffModal?.choose}</option>
            {salesLeadStatus?.map((data) => (
              <option key={data.id} value={data.id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <p>{EditReffPartner?.editReffModal?.startDate}</p>
          <SalesLeadDatePicker
            value={salesLead.startDate}
            onChange={(selectedDate) =>
              handleDateChange("startDate", selectedDate)
            }
          />
        </div>

        <div className="mb-3">
          <p>{EditReffPartner?.editReffModal?.endDate}</p>
          <SalesLeadDatePicker
            value={salesLead.endDate}
            onChange={(selectedDate) =>
              handleDateChange("endDate", selectedDate)
            }
          />
        </div>
      </div>
    </CommonModal>
  );
};

EdirRefferralEditSalesLeadModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  salesLeadStatus: PropTypes.array,
  salesDataProp: PropTypes.object,
  loadSelectedSalesLead: PropTypes.func.isRequired
};

export default EdirRefferralEditSalesLeadModal;
